import { useField } from 'formik'
import React from 'react'
import { Box, Text } from '@mantine/core'

interface Props {
  name: string;
  label?: string;
}

export default function StarRatingInput ({ name, label }: Props) {
  const [field, meta, helpers] = useField(name)
  const value = field.value ?? 0

  return (
    <Box sx={{ marginBottom: 12 }}>
      {label && (
        <Text size="sm" weight={500} mb={4}>
          {label}
        </Text>
      )}
      <div className="star-rating-input">
        {[1, 2, 3, 4, 5].map((star) => (
          <button
            key={star}
            type="button"
            className={star <= value ? 'star star--filled' : 'star'}
            onClick={() => helpers.setValue(star)}
            onBlur={() => helpers.setTouched(true)}
          >
            ★
          </button>
        ))}
      </div>
      {meta.touched && meta.error && (
        <Text size="sm" color="red" mt={4}>
          {meta.error}
        </Text>
      )}
    </Box>
  )
}
